import { get, isDate, isNil, isString, isNumber } from 'lodash';
import { isValid } from 'date-fns';

// Builds the `slotProps.textField` object shared by every picker wrapper so the
// rendered field matches the app's other small outlined text fields.
export function buildTextFieldSlotProps({ id, size = 'small', fullWidth = false, error = false, helperText, name, onBlur }) {
    return {
        // v8 only associates the <label> with the sectioned field when the text field has an id
        id,
        size,
        fullWidth,
        error,
        helperText,
        name,
        onBlur
    };
}

export function fieldErrorMessage(errors, name) {
    return get(errors, `${name}.message`);
}

// MUI X pickers only accept Date objects (or null); form state and API payloads in this app
// still hand them ISO strings, epoch numbers and '' for "empty", which the v5 pickers used to parse.
export function toPickerDate(value) {
    if (isNil(value) || value === '') {
        return null;
    }
    if (isDate(value)) {
        return value;
    }
    if (isString(value) || isNumber(value)) {
        return new Date(value);
    }
    return value;
}

export function isEmptyOrValidDate(date) {
    return isNil(date) || (isDate(date) && isValid(date));
}

// v8 tags every onAccept with where it came from: 'view' for the calendar / clock / OK / Clear /
// closing the popover, 'unknown' for edits typed into the sectioned field.
export function isViewAccept(context) {
    return context?.source === 'view';
}
